import React from "react";
import { IconButton, Tooltip, TablePagination } from "@mui/material";
import CommonTable, { HeadCell } from "src/business-types/grocery/components/CommonTable";
import { OrderData } from "../../../../types/order";
import { formatOrderDate } from "../../../../utils/dateUtils";
import ViewOrderButton from "../OrderActions/ViewOrderButton";
import { formatDate } from "src/shared/components/dateUtils";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "src/business-types/grocery/hooks/tableConfig";

interface OrderTableProps {
  data: OrderData[];
  page: number;
  rowsPerPage: number;
  totalRecords: number;
  onPageChange: (newPage: number) => void;
  onRowsPerPageChange: (newRowsPerPage: number) => void;
  onViewOrder: (orderId: string) => void;
  viewLoading: boolean;
}

type OrderRow = {
  id: string;
  sno: number;
  orderId: string;
  date: string;
  name: string;
  phone: string;
  staff: string;
  amount: string;
  actions: JSX.Element;
};


const OrderTable: React.FC<OrderTableProps> = ({ data, page, rowsPerPage, totalRecords, onPageChange, onRowsPerPageChange, onViewOrder, viewLoading }) => {
  // ✅ Map API data into table rows
  const rows: OrderRow[] = data.map((order, index) => ({
    id: order.Orderid,
    sno: page * rowsPerPage + index + 1,
    orderId: order.Orderid,
    date: formatDate(order.Orderdate),
    name: order.customer?.Name || "N/A",
    phone: order.customer?.phone_number || "N/A",
    staff: order.staffname || "N/A",
    amount: Number(order.Finalamount ?? 0).toFixed(2),
    actions: (
      <Tooltip title="View Order" placement="bottom" arrow>
        <span>
          <IconButton onClick={() => onViewOrder(order.Orderid)}>
            {" "}
            <ViewOrderButton orderId={order.Orderid} isLoading={viewLoading} onViewOrder={onViewOrder} />{" "}
          </IconButton>
        </span>
      </Tooltip>
    ),
  }));

  // ✅ Define table headers
  const headCells: HeadCell<OrderRow>[] = [
    { id: "sno", label: "S.No" },
    { id: "orderId", label: "Order ID" },
    { id: "date", label: "Date" },
    { id: "name", label: "Customer Name" },
    { id: "phone", label: "Phone Number" },
    { id: "staff", label: "Staff" },
    { id: "amount", label: "Amount" },
    { id: "actions", label: "Actions" },
  ];

  return (
    <div className="w-full overflow-y-auto">
      <CommonTable<OrderRow> 
          key={rowsPerPage} 
          data={rows} 
          headCells={headCells} 
          showToolbar={false} 
          denseDefault={false} 
          title="Orders" 
          pageSize={rowsPerPage} 
          pagenation={false} 
          selectable={false} 
          className="w-full min-w-[72vw] max-w-[100vw]"
        />

      <div className="flex justify-end mr-8 mt-2">
        <TablePagination
          component="div"
          count={totalRecords}
          page={page}
          onPageChange={(_, newPage) => onPageChange(newPage)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(e) => {
            const newSize = parseInt(e.target.value, 10);
            onRowsPerPageChange(newSize);
            onPageChange(0);
          }}
          rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        />
      </div>
    </div>
  );
};

export default OrderTable;
